<div class="content-block parcel-details">
    <div class="title-with-options bottom-line">
        <h2>Parcel Details</h2>
        <div class="option-buttons">
            <egov-responsive-toolbar
                [buttons]="[
                    { regularButton: cityTaxButton, menuItem: cityTaxMenuItem, menuItemGroup: 'tax-website' },
                    { regularButton: countyTaxButton, menuItem: countyTaxMenuItem, menuItemGroup: 'tax-website' },
                    { regularButton: appraiserButton, menuItem: appraiserMenuItem, menuItemGroup: 'appraiser-and-parcel-map' },
                    { regularButton: parcelMapButton, menuItem: parcelMapMenuItem, menuItemGroup: 'appraiser-and-parcel-map' }
                ]"
                [onlyMenu]="viewport.phone$ | async"
                [menuButton]="menuButton"
                [menuButtonEnabled]="(bill$ | async)?.satisfiesBillPage"
            >
                <ng-template #cityTaxButton>
                    <div>
                        <a *ngIf="cityTaxSite$ | async" mat-button [href]="cityTaxSite$ | async" target="_blank">
                            <span class="label">City Tax Website</span>
                            <mat-icon>location_city</mat-icon>
                        </a>
                        <button mat-button *ngIf="(cityTaxSite$ | async) === undefined" class="placeholder">
                            <egov-text-ui-placeholder class="label">City Tax Site</egov-text-ui-placeholder>
                            <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template #cityTaxMenuItem>
                    <a
                        mat-menu-item
                        *ngIf="(cityTaxSite$ | async) || (cityTaxSite$ | async) === undefined"
                        [href]="cityTaxSite$ | async"
                        target="_blank"
                        [disabled]="(cityTaxSite$ | async) === undefined"
                    >
                        City Tax Website
                        <mat-icon>open_in_new</mat-icon>
                    </a>
                </ng-template>
                <ng-template #countyTaxButton>
                    <div>
                        <a *ngIf="countyTaxSite$ | async" mat-button [href]="countyTaxSite$ | async" target="_blank">
                            <span class="label">County Tax Website</span>
                            <mat-icon class="right">park</mat-icon>
                        </a>
                        <button mat-button *ngIf="(countyTaxSite$ | async) === undefined" class="placeholder">
                            <egov-text-ui-placeholder class="label">County Tax Site</egov-text-ui-placeholder>
                            <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template #countyTaxMenuItem>
                    <a
                        mat-menu-item
                        *ngIf="(countyTaxSite$ | async) || (countyTaxSite$ | async) === undefined"
                        [href]="countyTaxSite$ | async"
                        target="_blank"
                        [disabled]="(countyTaxSite$ | async) === undefined"
                    >
                        County Tax Website
                        <mat-icon>open_in_new</mat-icon>
                    </a>
                </ng-template>
                <ng-template #appraiserButton>
                    <div>
                        <a *ngIf="appraiserURL$ | async" mat-button [href]="appraiserURL$ | async" target="_blank">
                            <span class="label">Appraiser Info</span>
                            <mat-icon class="right">assessment</mat-icon>
                        </a>
                        <button mat-button *ngIf="(appraiserURL$ | async) === undefined" class="placeholder">
                            <egov-text-ui-placeholder class="label">Appraiser Info</egov-text-ui-placeholder>
                            <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template #appraiserMenuItem>
                    <a mat-menu-item [href]="appraiserURL$ | async" target="_blank" [disabled]="(appraiserURL$ | async) === undefined">
                        Appraiser Info
                        <mat-icon>open_in_new</mat-icon>
                    </a>
                </ng-template>
                <ng-template #parcelMapButton>
                    <div>
                        <a
                            *ngIf="(state$ | async) === 'fl' && (parcelMapURL$ | async) !== undefined"
                            mat-button
                            [href]="parcelMapURL$ | async"
                            target="_blank"
                            [class.disabled]="(parcelMapURL$ | async) === null"
                            [class.no-pointer-events]="(parcelMapURL$ | async) === null"
                            [title]="(parcelMapURL$ | async) === null ? 'A parcel map is not available for this parcel.' : ''"
                        >
                            <span class="label">Parcel Map</span>
                            <mat-icon class="right">map</mat-icon>
                        </a>
                        <button mat-button *ngIf="(parcelMapURL$ | async) === undefined" class="placeholder">
                            <egov-text-ui-placeholder class="label">Parcel Map</egov-text-ui-placeholder>
                            <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
                        </button>
                    </div>
                </ng-template>
                <ng-template #parcelMapMenuItem>
                    <ng-container *ngIf="(state$ | async) === 'fl'">
                        <a
                            *ngIf="(parcelMapURL$ | async) !== null; else parcelMapUnavailable"
                            mat-menu-item
                            [href]="parcelMapURL$ | async"
                            target="_blank"
                            [disabled]="(parcelMapURL$ | async) === undefined"
                        >
                            Parcel Map
                            <mat-icon>open_in_new</mat-icon>
                        </a>
                        <ng-template #parcelMapUnavailable>
                            <a mat-menu-item href (click)="$event.preventDefault()" appModal="A parcel map is not available for this parcel."> Parcel Map </a>
                        </ng-template>
                    </ng-container>
                </ng-template>
                <ng-template #menuButton>
                    <app-icon-button [placeholder]="!(bill$ | async)?.satisfiesBillPage" title="More options"> more_vert </app-icon-button>
                </ng-template>
            </egov-responsive-toolbar>
        </div>
    </div>
    <div class="content-pane">
        <div class="info">
            <div class="data-field" *ngFor="let field of parcelDetails$ | async">
                <div class="label">
                    <ng-container *ngIf="field">{{ field.label }}</ng-container>
                    <egov-text-ui-placeholder *ngIf="!field" length="14" lengthThreshold="6"></egov-text-ui-placeholder>
                </div>
                <div class="content">
                    <ng-container *ngIf="field">{{ field.value }}</ng-container>
                    <egov-text-ui-placeholder *ngIf="!field" length="30" lengthThreshold="6"></egov-text-ui-placeholder>
                </div>
            </div>
        </div>
        <div class="map">
            <egov-map
                *ngIf="(parcel$ | async)?.coordinates"
                [latitude]="((parcel$ | async)?.coordinates)!.latitude"
                [longitude]="((parcel$ | async)?.coordinates)!.longitude"
            ></egov-map>
            <div *ngIf="(parcel$ | async)?.satisfiesBillPage && !(parcel$ | async)!.coordinates" class="map-placeholder"> Map unavailable for this parcel </div>
        </div>
    </div>
</div>
